export default __webpack_public_path__ + "static/media/txt-icon.2fb176cf.png";